// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_DashboardStatsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /contas/contas/dashboard_stats
 *
 * Fetches dashboard statistics. No body required.
 */
import { registerContract } from './validate'

export interface Contas_DashboardStatsInput {}

registerContract('Contas_DashboardStatsInput', {})
